// extracted by mini-css-extract-plugin
module.exports = {"passwordIcon":"Profile_passwordIcon__2EHBH","logoPreview":"Profile_logoPreview__7EjWj"};